"use client";

import { useEffect, useState, useSyncExternalStore, type CSSProperties } from "react";
import styles from "./CenteredHero.module.css";

/*
 * Préfixe fixe + mot qui change toutes les 3 s : les caractères du nouveau mot
 * réapparaissent en blur → net avec un léger décalage (reprise du hero du site).
 * Figé sur le premier mot si `prefers-reduced-motion`.
 */
const QUERY = "(prefers-reduced-motion: reduce)";
const subscribe = (onChange: () => void) => {
  const mq = window.matchMedia(QUERY);
  mq.addEventListener("change", onChange);
  return () => mq.removeEventListener("change", onChange);
};
const getReduced = () => window.matchMedia(QUERY).matches;

export function LoopingWords({ prefix, words }: { prefix: string; words: readonly string[] }) {
  const reduced = useSyncExternalStore(subscribe, getReduced, () => false);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (reduced || words.length <= 1) return;
    const id = window.setInterval(() => setIndex((i) => (i + 1) % words.length), 3000);
    return () => window.clearInterval(id);
  }, [reduced, words.length]);

  const word = words[index] ?? "";
  return (
    <span className={styles.loop}>
      <span className={styles.loopPrefix}>{prefix}</span>{" "}
      <span className={styles.loopWord} key={index}>
        {reduced
          ? word
          : Array.from(word).map((ch, i) => (
              <span key={i} className={styles.loopChar} style={{ animationDelay: `${i * 0.03}s` } as CSSProperties}>
                {ch}
              </span>
            ))}
      </span>
    </span>
  );
}
